const gameData = [
    `${process.env.PUBLIC_URL}/img1.jpg`,
    `${process.env.PUBLIC_URL}/img2.jpg`,
    `${process.env.PUBLIC_URL}/img3.jpg`,
    `${process.env.PUBLIC_URL}/img4.jpg`,
    `${process.env.PUBLIC_URL}/img1.jpg`,
    `${process.env.PUBLIC_URL}/img2.jpg`,
    `${process.env.PUBLIC_URL}/img3.jpg`,
    `${process.env.PUBLIC_URL}/img4.jpg`,
]

export default gameData;